// import headerImage from "../assets/image/logo.webp";
import headerImage from "../assets/image/logos/lawBlocks-full-logo-white.svg";
import { NavLink } from "react-router-dom";
import { IconBrandLinkedinFilled } from "@tabler/icons-react";
import { IconBrandTelegram } from "@tabler/icons-react";
import { IconBrandYoutubeFilled } from "@tabler/icons-react";
import { IconBrandGmail } from "@tabler/icons-react";
import { IconBrandGithubFilled } from "@tabler/icons-react";
import { IconBrandReddit } from "@tabler/icons-react";
import { IconBrandDiscord } from "@tabler/icons-react";
import XIcon from "@mui/icons-material/X";
import paths from "../utils/paths";

export default function Footer() {
  return (
    <section className="footer-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div className="col-lg-8">
              <div className="footer-content">
                <img
                  src={headerImage}
                  alt="Header"
                  style={{ width: "180px" }}
                />
                <p>
                  Take the stress out of handling legal challenges with Law
                  Blocks AI. Our platform combines the power of blockchain and
                  AI to make your legal processes secure, clear, and easy. Built
                  for experts like you, we're here to help you navigate the
                  future of law with confidence.
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="footer-step">
              <h4>STEP BY STEP GUIDES</h4>
              <ul>
                <li>
                  <NavLink to="/" className="step-text">
                    Login
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={paths.CreateDocumentWithAi}
                    className="step-text"
                  >
                    Create Template with AI
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to={paths.CreateDocumentWithAi}
                    className="step-text"
                  >
                    Upload Contract
                  </NavLink>
                </li>
                <li>
                  <NavLink to={paths.Chat} className="step-text">
                    AI Chat
                  </NavLink>
                </li>
                <li>
                  <NavLink to={paths.LegalDocuments} className="step-text">
                    Legal Documents
                  </NavLink>
                </li>
                <li>
                  <NavLink to={paths.DigitalDashboard} className="step-text">
                    Digital Signature
                  </NavLink>
                </li>
                <li>
                  <NavLink to={paths.Arbitrators} className="step-text">
                    Arbitration & Mediation
                  </NavLink>
                </li>
                <li>
                  <NavLink to={paths.FAQs} className="step-text">
                    FAQ's
                  </NavLink>
                </li>
                <li>
                  <NavLink to={paths.ApiDocsPublic} className="step-text">
                    APIs Documentation
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-3">
            <div className="footer-step">
              <h4>VIRTUAL ARBITRATION HEARING</h4>
              <ul>
                <li>
                  {" "}
                  <NavLink to="/" className="step-text">
                    VAH FAQ's
                  </NavLink>
                </li>
              </ul>
              <h4 className="mt-4">CONTACT US:</h4>
              <ul>
                <li>
                  <a href="mailto:info@lawblocks.io" className="step-text">
                    Email: info@lawblocks.io
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="media-links">
          <ul>
            <li>
              {" "}
              <NavLink
                to="https://twitter.com/lawblockstoken"
                target="_blank"
                className="step-text"
              >
                <XIcon />
              </NavLink>
            </li>
            <li>
              <NavLink
                to="https://www.linkedin.com/company/lawblocks/"
                target="_blank"
                className="step-text"
              >
                <IconBrandLinkedinFilled />
              </NavLink>
            </li>
            <li>
              <NavLink
                to="https://t.me/LawBlocks_updates"
                target="_blank"
                className="step-text"
              >
                <IconBrandTelegram stroke={2} />
              </NavLink>
            </li>
            <li>
              {" "}
              <NavLink
                to="https://www.youtube.com/channel/UCbg3ToXjksIHOpsxl8YsO_A"
                target="_blank"
                className="step-text"
              >
                <IconBrandYoutubeFilled />
              </NavLink>
            </li>
            <li>
              {" "}
              <NavLink
                to="https://medium.com/@lawblocks"
                target="_blank"
                className="step-text"
              >
                <IconBrandGmail stroke={2} />
              </NavLink>
            </li>
            <li>
              <NavLink
                to="https://github.com/LawBlocks"
                target="_blank"
                className="step-text"
              >
                <IconBrandGithubFilled />
              </NavLink>
            </li>
            <li>
              {" "}
              <NavLink
                to="https://www.reddit.com/user/LawBlocks/?rdt=60186"
                target="_blank"
                className="step-text"
              >
                <IconBrandReddit stroke={2} />
              </NavLink>
            </li>
            <li>
              <NavLink
                to="http://discord.com/invite/e9cKqusTDB"
                target="_blank"
                className="step-text"
              >
                <IconBrandDiscord stroke={2} />
              </NavLink>
            </li>
          </ul>
        </div>
        <div className="terms">
          <p>Terms and conditions </p>
          <p>Privacy policy</p>
        </div>
      </div>
    </section>
  );
}
